<template>
<div>
    <Proveedor/> 
    <GestionProveedores/>  
     
</div> 

</template>

<script>

import Proveedor from '../components/Proveedor.vue'
import GestionProveedores from '../components/GestionProveedores.vue'




export default {
    components:{
        Proveedor,
        GestionProveedores,
        
    }
}
</script>

<style>

</style>

    